import {HttpErrorResponse} from '@angular/common/http';
import { throwError } from 'rxjs';
export class BaseService {
  constructor() {
  }
  protected handleError(errorResponse: HttpErrorResponse) {
    return throwError(errorResponse.error || {exception: 'unknownError', language: 'PORTUGUESE'});
  }
}
